var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragDisabled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.275,
    height: 12.043,
    viewBox: "0 0 11.275 12.043",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(-2960.863 57.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M4.129,3.18a1.167,1.167,0,0,1-.942-1.854L4.519,3.113A1.163,1.163,0,0,1,4.129,3.18Zm.979-.531h0L3.8.893A1.167,1.167,0,0,1,5.109,2.647Z",
    transform: "translate(2960.037 -57.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M15.833,23.667A1.167,1.167,0,1,1,14.667,22.5,1.167,1.167,0,0,1,15.833,23.667Z",
    transform: "translate(2949.5 -69.834)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M21.833,11.667A1.167,1.167,0,1,1,20.667,10.5,1.167,1.167,0,0,1,21.833,11.667Z",
    transform: "translate(2948.167 -67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M8.8,12.845a1.167,1.167,0,0,1-.978-1.8L9.125,12.8A1.169,1.169,0,0,1,8.8,12.845Zm.943-.479h0L8.407,10.579a1.167,1.167,0,0,1,1.333,1.786Z",
    transform: "translate(2960.037 -57.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M9.08,7.978h0L7.793,6.251A1.167,1.167,0,1,1,9.08,7.978Z",
    transform: "translate(2960.037 -57.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M4.129,8.013a1.167,1.167,0,0,1-.283-2.3L5.133,7.441A1.173,1.173,0,0,1,4.129,8.013Z",
    transform: "translate(2960.037 -57.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M13.282,14.789a.616.616,0,0,1-.455-.2L3.94,4.951a.749.749,0,0,1,0-.994.608.608,0,0,1,.912,0l8.887,9.633a.749.749,0,0,1,0,.994A.617.617,0,0,1,13.282,14.789Z",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 2958.679, -61.143)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag_disabled.fa4ae9895c3053fb88424c5579b02245.svg";